var __rspack_ns_object = {"rE":"0.1.0"}